import React from 'react';
import useRole from '../../hooks/getRole';
import AdminCreditUsageView from './AdminCreditUsageView';
import SuperAdminCostView from './SuperAdminCostView';

const Index = () => {
  const role = String(useRole() || '').toLowerCase();

  if (role === 'super_admin') {
    return <SuperAdminCostView />;
  }

  if (role === 'admin') {
    return <AdminCreditUsageView />;
  }

  return null;
};

export default Index;
